module.exports = __webpack_public_path__ + "images/embed/icons/user_add.png";